var _title, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcFormatListBulleted = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "List bulleted")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "pirosol1",
    x: 0,
    y: 0,
    width: 1280,
    height: 885
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.4%",
    y: "-0.5%",
    width: "100.8%",
    height: "101.1%",
    filterUnits: "objectBoundingBox",
    id: "pirosol5"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "pirosol2",
    x: 0,
    y: 0,
    width: 850,
    height: 586,
    rx: 2
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-0.6%",
    y: "-0.7%",
    width: "101.2%",
    height: "101.7%",
    filterUnits: "objectBoundingBox",
    id: "pirosol6"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333333,8.75 C2.64166667,8.75 2.08333333,9.30833333 2.08333333,10 C2.08333333,10.6916667 2.64166667,11.25 3.33333333,11.25 C4.025,11.25 4.58333333,10.6916667 4.58333333,10 C4.58333333,9.30833333 4.025,8.75 3.33333333,8.75 L3.33333333,8.75 Z M3.33333333,3.75 C2.64166667,3.75 2.08333333,4.30833333 2.08333333,5 C2.08333333,5.69166667 2.64166667,6.25 3.33333333,6.25 C4.025,6.25 4.58333333,5.69166667 4.58333333,5 C4.58333333,4.30833333 4.025,3.75 3.33333333,3.75 L3.33333333,3.75 Z M3.33333333,13.8916667 C2.71666667,13.8916667 2.225,14.3916667 2.225,15 C2.225,15.6083333 2.725,16.1083333 3.33333333,16.1083333 C3.94166667,16.1083333 4.44166667,15.6083333 4.44166667,15 C4.44166667,14.3916667 3.95,13.8916667 3.33333333,13.8916667 L3.33333333,13.8916667 Z M5.83333333,15.8333333 L17.5,15.8333333 L17.5,14.1666667 L5.83333333,14.1666667 L5.83333333,15.8333333 L5.83333333,15.8333333 Z M5.83333333,10.8333333 L17.5,10.8333333 L17.5,9.16666667 L5.83333333,9.16666667 L5.83333333,10.8333333 L5.83333333,10.8333333 Z M5.83333333,4.16666667 L5.83333333,5.83333333 L17.5,5.83333333 L17.5,4.16666667 L5.83333333,4.16666667 L5.83333333,4.16666667 Z",
    id: "pirosol3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pirosol4",
    x: 0,
    y: 0,
    width: 41.6666667,
    height: 41.6666667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pirosol7",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pirosol8",
    transform: "translate(-1000.000000, -404.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "pirosol21",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 123.5,
    width: 1441,
    height: 901
  }), /*#__PURE__*/React.createElement("g", {
    id: "pirosol19",
    transform: "translate(80.000000, 139.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pirosol20"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#pirosol5)",
    xlinkHref: "#pirosol1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#pirosol1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pirosol9",
    transform: "translate(400.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pirosol10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pirosol2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pirosol12"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#pirosol6)",
    xlinkHref: "#pirosol2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#pirosol2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pirosol11",
    mask: "url(#pirosol10)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pirosol12",
    stroke: "#DFE2E5",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 850,
    height: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "pirosol17",
    stroke: "none",
    fill: "none",
    transform: "translate(518.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pirosol16",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pirosol3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "pirosol12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "pirosol14",
    mask: "url(#pirosol16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.833333, -10.833333)",
    id: "pirosol15"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pirosol18",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#pirosol4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "pirosol13",
    fill: "#4F5964",
    xlinkHref: "#pirosol4"
  }))))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcFormatListBulleted, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-format-list-bulleted.39524e98.svg";
export { ForwardRef as ReactComponent };